(ns motorsaif.constants)

(def service-types
  [{:repairs "Repairs"}
   {:upgrades "Modifications"}
   {:new-parts "New Parts"}
   {:used-parts "Used Parts"}])

;; Badge classes (css) success, default, warning, danger
;; Indicator true/false shows a glowing dot, used when the user should wait for us.
(def interaction-status
  {:part
   [{:id :introduction
     :label "Introduction"
     :description "The conversation has just started. We're discussing your parts request and gathering initial details."
     :badge-class "default"
     :next-options #{:sourcing}
     :indicator false
     :assigned :business
     :priority :low}

    {:id :sourcing
     :label "Sourcing"
     :description "We're checking with suppliers to confirm availability, pricing, warranty, and lead-times."
     :badge-class "warning"
     :time {:min 24 :max 96}
     :next-options #{:awaiting-quote-approval :sourcing-failed} ;; MODIFIED: Added failure path
     :indicator true
     :assigned :business
     :priority :low}

    ;; ADDED: New state for when sourcing fails
    {:id :sourcing-failed
     :label "Sourcing Failed"
     :customer-label "Reviewing Options"
     :description "We were unable to source the requested part. It may be obsolete or unavailable. Please contact us to discuss alternatives."
     :customer-description "We're exploring alternative options and will contact you shortly to discuss available solutions."
     :badge-class "danger"
     :customer-badge-class "warning"
     :time {:min 1 :max 2}
     :next-options #{:cancelled}
     :indicator false
     :assigned :business
     :priority :high}

    {:id :awaiting-quote-approval
     :label "Awaiting Quote Approval"
     :description "A detailed quotation has been sent for your review. Please approve or decline to proceed."
     :badge-class "warning"
     :time {:min 1 :max 48}
     :next-options #{:awaiting-payment :quote-rejected} ;; MODIFIED: Added rejection path
     :indicator false
     :assigned :customer
     :priority :medium}

    ;; ADDED: New state for when a customer rejects a quote
    {:id :quote-rejected
     :label "Quote Rejected"
     :description "You have declined the quotation. This order will now be cancelled."
     :badge-class "default"
     :time {:min 1 :max 2}
     :next-options #{:cancelled}
     :indicator false
     :assigned :customer
     :priority :high}

    {:id :awaiting-payment
     :label "Awaiting Payment"
     :description "Quotation accepted. Please submit payment to confirm the order."
     :badge-class "danger"
     :time {:min 1 :max 72}
     :next-options #{:purchasing}
     :indicator false
     :assigned :customer
     :priority :medium}

    {:id :purchasing
     :label "Purchasing"
     :description "We have received your payment and are now buying the part from our vendor."
     :badge-class "warning"
     :time {:min 2 :max 24}
     :next-options #{:shipment-details :pickup-details}
     :indicator true
     :assigned :business
     :priority :low}

    {:id :shipment-details
     :label "Shipment Details"
     :description "We require your time, location, and phone number to coordinate shipping."
     :badge-class "default"
     :time {:min 1 :max 12}
     :next-options #{:in-transit}
     :indicator false
     :assigned :customer
     :priority :medium}

    {:id :pickup-details
     :label "Pickup Details"
     :description "We need to coordinate a convenient time and location for you to collect your parts."
     :badge-class "default"
     :time {:min 1 :max 12}
     :next-options #{:ready-for-pickup}
     :indicator false
     :assigned :customer
     :priority :medium}

    {:id :in-transit
     :label "In Transit"
     :description "Your parts have been handed over to the carrier and are on their way."
     :badge-class "warning"
     :time {:min 24 :max 168}
     :next-options #{:delivered}
     :indicator true
     :assigned :business
     :priority :low}

    {:id :ready-for-pickup
     :label "Ready for Pickup"
     :description "Your parts are ready for collection at our location. Please bring your order confirmation."
     :badge-class "success"
     :time {:min 1 :max 72}
     :next-options #{:collected}
     :indicator false
     :assigned :customer
     :priority :medium}

    {:id :delivered
     :label "Delivered"
     :description "Delivery confirmed. Let us know if anything is missing or damaged."
     :badge-class "success"
     :next-options #{}
     :indicator false
     :assigned :customer
     :priority :low}

    {:id :collected
     :label "Collected"
     :description "Parts successfully collected. Thank you for choosing us!"
     :badge-class "success"
     :next-options #{}
     :indicator false
     :assigned :customer
     :priority :low}

    ;; ADDED: New terminal state for cancelled orders
    {:id :cancelled
     :label "Cancelled"
     :description "This order has been cancelled."
     :badge-class "default"
     :next-options #{}
     :indicator false
     :assigned :business
     :priority :low}]


   ;; ======================================================================
   ;; Refactored :repair flow (incorporating logic from the flowchart critique)
   ;; ======================================================================
   :repair
   [{:id :introduction
     :label "Introduction"
     :description "The conversation has just started. We're discussing your request and gathering initial details."
     :badge-class "default"
     :next-options #{:initial-estimate :awaiting-delivery :recovery-pickup}
     :indicator false
     :assigned :business
     :priority :medium}

    {:id :initial-estimate
     :label "Initial Estimate"
     :description "We're providing you with a preliminary estimate based on the initial problem description."
     :badge-class "default"
     :time {:min 1 :max 24}
     :next-options #{:awaiting-delivery :recovery-pickup}
     :indicator true
     :assigned :business
     :priority :high}

    {:id :awaiting-delivery
     :label "Awaiting Delivery"
     :description "Please arrange to drop off your vehicle at our workshop."
     :badge-class "warning"
     :time {:min 2 :max 48}
     :next-options #{:diagnostics}
     :indicator true
     :assigned :customer
     :priority :low}

    {:id :recovery-pickup
     :label "Arranging Recovery"
     :description "We're coordinating vehicle recovery. Please provide your car's location so we can arrange pickup."
     :badge-class "warning"
     :time {:min 4 :max 24}
     :next-options #{:diagnostics}
     :indicator true
     :assigned :customer
     :priority :medium}

    {:id :diagnostics
     :label "Diagnostics"
     :description "We're inspecting your vehicle to pinpoint the issue and required work."
     :badge-class "warning"
     :time {:min 2 :max 8}
     :next-options #{:awaiting-quote-approval :not-repairable} ;; MODIFIED: Added failure path
     :indicator true
     :assigned :business
     :priority :low}

    ;; ADDED: New state for unrepairable items
    {:id :not-repairable
     :label "Not Repairable"
     :customer-label "Diagnostics Complete"
     :description "Following diagnostics, we've determined the item is not economically or technically repairable. Please contact us to discuss diagnostic fees and arrange collection."
     :customer-description "Diagnostics are complete. We'll contact you to discuss our findings and next steps."
     :badge-class "danger"
     :customer-badge-class "default"
     :time {:min 1 :max 2}
     :next-options #{:awaiting-payment :car-ready} ;; Can go to payment for diagnostic fees or directly to car-ready if waived
     :indicator false
     :assigned :business
     :priority :high}

    {:id :awaiting-quote-approval
     :label "Awaiting Quote Approval"
     :description "A cost and timeline quotation has been sent for your review. Please approve or decline so we can continue."
     :badge-class "warning"
     :time {:min 1 :max 72}
     ;; MODIFIED: Added rejection and clarified forward paths
     :next-options #{:awaiting-parts :repair-in-progress :quote-rejected}
     :indicator false
     :assigned :customer
     :priority :medium}

    ;; ADDED: New state for rejected quotes
    {:id :quote-rejected
     :label "Quote Rejected"
     :description "You have declined the repair quotation. Please contact us to discuss diagnostic fees and arrange collection."
     :badge-class "default"
     :time {:min 1 :max 2}
     :next-options #{:car-ready :awaiting-quote-approval} ;; Can go to payment for diagnostic fees or directly to car-ready if waived
     :indicator false
     :assigned :customer
     :priority :high}

    {:id :awaiting-parts
     :label "Awaiting Parts"
     :description "Quotation approved—necessary parts are being sourced."
     :badge-class "warning"
     :time {:min 24 :max 168}
     :next-options #{:repair-in-progress :not-repairable} ;; MODIFIED: Added failure path
     :indicator true
     :assigned :business
     :priority :low}

    {:id :repair-in-progress
     :label "Repair In Progress"
     :description "A technician is actively working on your repair."
     :badge-class "warning"
     :time {:min 2 :max 24}
     :next-options #{:quality-check :awaiting-parts-payment :awaiting-quote-approval}
     :indicator true
     :assigned :business
     :priority :low}

    {:id :awaiting-parts-payment
     :label "Awaiting Parts Payment"
     :customer-label "Additional Payment Required"
     :description "We need payment for expensive parts before we can continue with the repair."
     :customer-description "Additional payment is required for specialized parts before we can proceed with your repair."
     :badge-class "danger"
     :time {:min 1 :max 72}
     :next-options #{:repair-in-progress}
     :indicator false
     :assigned :customer
     :priority :medium}

    {:id :quality-check
     :label "Quality Check"
     :description "Repair complete. We're testing to ensure everything works correctly."
     :badge-class "default"
     :time {:min 1 :max 4}
     :next-options #{:repair-completed :qc-failed} ;; MODIFIED: Goes to repair-completed instead of payment
     :indicator true
     :assigned :business
     :priority :low}

    {:id :repair-completed
     :label "Repair Completed"
     :description "Your vehicle has been successfully repaired and passed all quality checks."
     :badge-class "success"
     :time {:min 1 :max 2}
     :next-options #{:awaiting-payment}
     :indicator false
     :assigned :business
     :priority :high}

    ;; ADDED: New state for failed QC
    {:id :qc-failed
     :label "Quality Check Failed"
     :customer-label "Quality Testing"
     :description "Our quality check revealed an issue. The item is being returned to our technician for re-work."
     :customer-description "We're performing final quality checks to ensure everything meets our standards."
     :badge-class "danger"
     :customer-badge-class "warning"
     :time {:min 1 :max 2}
     :next-options #{:repair-in-progress} ;; This creates the critical feedback loop
     :indicator true
     :assigned :business
     :priority :high}

    {:id :awaiting-payment
     :label "Awaiting Payment"
     :description "The final invoice is ready; please settle payment to proceed."
     :badge-class "danger"
     :time {:min 1 :max 72}
     :next-options #{:car-ready}
     :indicator false
     :assigned :customer
     :priority :medium}

    {:id :car-ready
     :label "Car Ready"
     :description "Your vehicle is ready for collection. Please choose your preferred collection method."
     :badge-class "success"
     :time {:min 1 :max 24}
     :next-options #{:arranging-recovery :ready-for-pickup}
     :indicator false
     :assigned :customer
     :priority :medium}

    {:id :arranging-recovery
     :label "Arranging Recovery"
     :description "We're arranging to deliver your vehicle back to you. Please confirm your preferred drop-off location and time."
     :badge-class "warning"
     :time {:min 2 :max 24}
     :next-options #{:delivered-via-recovery}
     :indicator true
     :assigned :customer
     :priority :low}

    {:id :ready-for-pickup
     :label "Ready for Pickup"
     :description "Your vehicle has passed testing and is ready for collection at our workshop."
     :badge-class "success"
     :time {:min 1 :max 24}
     :next-options #{:collected}
     :indicator false
     :assigned :customer
     :priority :low}

    ;; ADDED: Specific terminal states for consistency
    {:id :delivered-via-recovery
     :label "Delivered via Recovery"
     :description "Your vehicle has been delivered to your specified location. Thank you for choosing us!"
     :badge-class "success"
     :next-options #{}
     :indicator false
     :assigned :customer
     :priority :low}

    {:id :collected
     :label "Collected"
     :description "Your vehicle has been collected from our workshop. Thank you for choosing us!"
     :badge-class "success"
     :next-options #{}
     :indicator false
     :assigned :customer
     :priority :low}]

   ;; The :upgrade flow would be refactored using the same principles as the :repair flow.
   ;; I've omitted it for brevity but it would include states like :quote-rejected and :qc-failed.
   :upgrade
   [{:id :introduction
     :label "Introduction"
     :description "The conversation has just started. We're discussing your upgrade or modification request and gathering initial details."
     :badge-class "default"
     :next-options #{:consultation}
     :indicator false
     :assigned :business
     :priority :low}

    {:id :consultation
     :label "Consultation"
     :description "We're discussing options, compatibility, and your preferences for the upgrade."
     :badge-class "default"
     :time {:min 2 :max 24}
     :next-options #{:sourcing-parts}
     :indicator true
     :assigned :business
     :priority :low}

    {:id :sourcing-parts
     :label "Sourcing Parts"
     :description "We're sourcing the required parts or components for your upgrade."
     :badge-class "warning"
     :time {:min 24 :max 120}
     :next-options #{:awaiting-quote-approval :sourcing-failed} ;; MODIFIED: Added failure path
     :indicator true
     :assigned :business
     :priority :low}

    ;; ADDED: New state for when sourcing parts fails.
    {:id :sourcing-failed
     :label "Sourcing Failed"
     :customer-label "Reviewing Options"
     :description "We were unable to source the required parts. They may be obsolete or unavailable. The order has been cancelled."
     :customer-description "We're exploring alternative options and will contact you shortly to discuss available solutions."
     :badge-class "danger"
     :customer-badge-class "warning"
     :time {:min 1 :max 2}
     :next-options #{:cancelled}
     :indicator false
     :assigned :business
     :priority :high}

    {:id :awaiting-quote-approval
     :label "Awaiting Quote Approval"
     :description "A detailed quotation for the upgrade has been sent for your review. Please approve or decline so we can proceed."
     :badge-class "warning"
     :time {:min 1 :max 72}
     :next-options #{:awaiting-payment :quote-rejected} ;; MODIFIED: Added rejection path
     :indicator false
     :assigned :customer
     :priority :medium}

    ;; ADDED: New state for when a customer rejects a quote.
    {:id :quote-rejected
     :label "Quote Rejected"
     :description "You have declined the quotation. This order will now be cancelled."
     :badge-class "default"
     :time {:min 1 :max 2}
     :next-options #{:cancelled}
     :indicator false
     :assigned :customer
     :priority :high}

    {:id :awaiting-payment
     :label "Awaiting Payment"
     :description "Quote accepted. Please submit payment to confirm your upgrade order."
     :badge-class "danger"
     :time {:min 1 :max 72}
     :next-options #{:upgrade-in-progress}
     :indicator false
     :assigned :customer
     :priority :medium}

    {:id :upgrade-in-progress
     :label "Upgrade In Progress"
     :description "Our technicians are performing the requested upgrade or modification."
     :badge-class "warning"
     :time {:min 4 :max 48}
     :next-options #{:quality-check}
     :indicator true
     :assigned :business
     :priority :low}

    {:id :quality-check
     :label "Quality Check"
     :description "Upgrade complete. We're testing and inspecting to ensure everything works as expected."
     :badge-class "default"
     :time {:min 1 :max 4}
     :next-options #{:ready-for-pickup :arranging-delivery :qc-failed} ;; MODIFIED: Added QC failure loop and delivery option.
     :indicator true
     :assigned :business
     :priority :low}

    ;; ADDED: New state for a failed Quality Check.
    {:id :qc-failed
     :label "Quality Check Failed"
     :description "Our quality check revealed an issue. The item is being returned to our technician for re-work."
     :badge-class "danger"
     :time {:min 1 :max 2}
     :next-options #{:upgrade-in-progress} ;; This creates the feedback loop.
     :indicator true
     :assigned :business
     :priority :high}

    {:id :ready-for-pickup
     :label "Ready for Pickup"
     :description "Your vehicle is ready for collection with the completed upgrade."
     :badge-class "success"
     :time {:min 1 :max 24}
     :next-options #{:collected} ;; MODIFIED: Specific terminal state.
     :indicator false
     :assigned :customer
     :priority :low}

    ;; ADDED: New state for arranging delivery post-upgrade.
    {:id :arranging-delivery
     :label "Arranging Delivery"
     :description "We're arranging to return your vehicle. Please confirm your preferred drop-off location and time."
     :badge-class "warning"
     :time {:min 2 :max 24}
     :next-options #{:delivered}
     :indicator true
     :assigned :customer
     :priority :low}

    ;; ADDED: Specific terminal states for clarity, replacing generic "completed".
    {:id :collected
     :label "Collected"
     :description "The upgrade is complete and your vehicle has been collected. Thank you!"
     :badge-class "success"
     :next-options #{}
     :indicator false
     :assigned :customer
     :priority :low}

    {:id :delivered
     :label "Delivered"
     :description "The upgrade is complete and your vehicle has been delivered. Thank you!"
     :badge-class "success"
     :next-options #{}
     :indicator false
     :assigned :customer
     :priority :low}

    {:id :cancelled
     :label "Cancelled"
     :description "This upgrade order has been cancelled."
     :badge-class "default"
     :next-options #{}
     :indicator false
     :assigned :business
     :priority :low}]
   })
